import React, { useEffect, useState } from "react";
import "../../pages/analytics/analytics.css";
import "../orderManagement/OrderDetails/refundDialog.css";
import { Dialog, DialogActions, Typography, Button } from "@mui/material";
import { Navigate } from "react-router";
import { useAuth } from "../../context/API_Client";

const ConflictIdentityErrorModal = ({ open }) => {
  const [isOpen, setIsOpen] = useState(open);

  const handleClick = () => {
    window.location.reload();
    localStorage.removeItem("merchantSettings");
    setIsOpen(false);
  };

  return (
    <Dialog
      open={isOpen}
      PaperProps={{
        style: {
          backgroundColor: "#FFF",
          borderRadius: "12px",
          width: "416px",
        },
      }}
    >
      <div className="void-card">
        <div className="void-img">
          <img src="/assets/orderDetailsIcons/ExclamationCircle-yellow.svg" />
        </div>
        <div>
          <Typography
            className="bodyB1Medium"
            sx={{
              color: "var(--character-title-85, rgba(0, 0, 0, 0.85))",
              marginBottom: "8px",
            }}
          >
            Info
          </Typography>
          <Typography
            className="bodyB2RegularText"
            sx={{ color: "var(--text-medium, rgba(1, 1, 2, 0.60))" }}
          >
            Things have updated since you last refreshed the page. Please
            refresh to see the changes been made
          </Typography>
        </div>
      </div>
      <DialogActions className="card-footer">
        <Button
          sx={{ "&:hover": { backgroundColor: "var(--neutral-1, #FFF)" } }}
          variant="contained"
          disableRipple
          disableElevation
          className="btn cancel-btn"
          onClick={() => setIsOpen(false)}
        >
          <Typography className="bodyB2MediumColored">Cancel</Typography>
        </Button>
        <Button
          sx={{
            "&:hover": { backgroundColor: "var(--generic-primary, #24B7AA)" },
          }}
          variant="contained"
          disableRipple
          disableElevation
          className="btn refund-btn"
          onClick={handleClick}
        >
          <Typography className="bodyB2Medium" style={{ color: "white" }}>
            Refresh
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConflictIdentityErrorModal;
